/* eslint-disable no-console */
import { client } from "."; // ← el cliente oficial de Supabase

export const getUsers = async ({ includeDisabled = false } = {}) => {
  try {
    // Supabase tiene límite de 1000 por defecto, aumentamos a 5000 para traer todos
    let query = client.from("usuarios").select("*");

    // Por defecto se excluyen los suspendidos (cero regresión para otros consumidores).
    // includeDisabled === true los incluye (solo admins en Usuarios/index.js).
    if (!includeDisabled) {
      query = query.neq("habilitado", false);
    }

    const { data, error } = await query.order("id", { ascending: false }).limit(5000);

    if (error) throw error;

    if (!data || data.length === 0) {
      return [];
    }

    return data;
  } catch (error) {
    console.error("Error en getUsers:", error);
    return [];
  }
};
